<template>
  <div>
    <!-- breadcrumb start -->
    <div class="breadcrumb-section">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="page-title">
              <h2>我的页面</h2>
            </div>
          </div>
          <div class="col-sm-6">
            <nav aria-label="breadcrumb" class="theme-breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="./index.html">主页</a></li>
                <li class="breadcrumb-item active" aria-current="page" @click="goMyPage" style="cursor: pointer;">我的页面</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <!-- breadcrumb End -->
    <section class="tracking-page section-b-space">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <h3>订单号: {{ trade.trade_no }}</h3>
            <div class="row border-part">
              <div class="col-xl-4 col-md-4 col-sm-4">
                <div class="product-detail" style="display: flex; justify-content: center;">
                  <img :src="trade.product_data[0]['pic']" class="img-fluid blur-up lazyloaded" alt="" v-if="trade.product_data.length > 0" style="max-width: 200px;">
                </div>
              </div>
              <div class="col-xl-8 col-lg-8 col-sm-8" v-if="trade.type === 'goods'">
                <div class="tracking-detail">
                  <ul>
                    <li>
                      <div class="left">
                        <span>订单日期</span>
                      </div>
                      <div class="right">
                        <span>{{ trade.create_time | timestamp2date }}</span>
                      </div>
                    </li>
                    <li v-if="trade.payment_data.gmt_payment">
                      <div class="left">
                        <span>支付日期</span>
                      </div>
                      <div class="right">
                        <span>{{ trade.payment_data.gmt_payment }}</span>
                      </div>
                    </li>
                    <li>
                      <div class="left">
                        <span>订单信息</span>
                      </div>
                      <div class="right">
                        <p v-for="goods in trade.product_data" :key="goods.plan.plan_id">{{ goods.plan.name }} - {{ goods.service.name }} * {{ goods.qty }}</p>
                      </div>
                    </li>
                    <li v-if="trade.express_data.lastname">
                      <div class="left">
                        <span>收货地址</span>
                      </div>
                      <div class="right">
                        <span>
                          {{ trade.express_data.postal }}<br/>
                          {{ trade.express_data.address }}, {{ trade.express_data.city }}<br/>
                          {{ trade.express_data.province }}, {{ trade.express_data.country }}<br/>
                          {{ trade.express_data.firstname }} {{ trade.express_data.lastname }}<br/>
                          {{ trade.express_data.mobile_code }} - {{ trade.express_data.mobile }}<br/>
                        </span>
                      </div>
                    </li>
                    <li v-if="trade.express_data.lastname">
                      <div class="left">
                        <span>物流公司</span>
                      </div>
                      <div class="right">
                        <span v-if="trade.express_data.carrier">{{ trade.express_data.carrier }}</span>
                        <span v-else>-</span>
                      </div>
                    </li>
                    <li v-if="trade.express_data.lastname">
                      <div class="left">
                        <span>物流单号</span>
                      </div>
                      <div class="right">
                        <span v-if="trade.express_data.ship_no">{{ trade.express_data.ship_no }}</span>
                        <span v-else>-</span>
                      </div>
                    </li>
                    <li>
                      <div class="left">
                        <span>备注</span>
                      </div>
                      <div class="right">
                        <div>
                          <span v-for="product in trade.product_data" :key="product.plan.plan_id">
                            <span v-for="token in product.token" :key="token">兑换码：{{ token }}</span>
                          </span>
                        </div>
                        <span v-if="trade.detail">
                          <div v-html="trade.detail.replaceAll('\n', '<br/>')"></div>
                        </span>
                        <span v-else>-</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-xl-8 col-lg-8 col-sm-8" v-else-if="trade.type === 'service'">
                <div class="tracking-detail">
                  <ul>
                    <li>
                      <div class="left">
                        <span>订单日期</span>
                      </div>
                      <div class="right">
                        <span>{{ trade.create_time | timestamp2date }}</span>
                      </div>
                    </li>
                    <li v-if="trade.payment_data.gmt_payment">
                      <div class="left">
                        <span>支付日期</span>
                      </div>
                      <div class="right">
                        <span>{{ trade.payment_data.gmt_payment }}</span>
                      </div>
                    </li>
                    <li>
                      <div class="left">
                        <span>订单信息</span>
                      </div>
                      <div class="right">
                        {{ trade.product_data[0].service.name }}
                      </div>
                    </li>
                    <li>
                      <div class="left">
                        <span>设备信息</span>
                      </div>
                      <div class="right">
                        {{ trade.device.mac }}
                      </div>
                    </li>
                    <li>
                      <div class="left">
                        <span>有效期至</span>
                      </div>
                      <div class="right">
                        {{ trade.data.device.end_time | timestamp2date }}
                      </div>
                    </li>
                  </ul>
                </div>
                <a>* 如充值遇到问题，请联系客服。</a>
              </div>
            </div>
            <div class="wrapper" v-if="[1,2,10].includes(trade.status) && trade.type === 'goods' && trade.express_data.lastname">
              <div class="arrow-steps clearfix">
                <div class="step" :class="{'current': trade.status === 1, 'done': trade.status >= 1}"><span>已支付</span></div>
                <div class="step" :class="{'current': trade.express_data.ship_no === '' && trade.status === 1, 'done': trade.status >= 2}"><span>打包中</span></div>
                <div class="step" :class="{'current': (trade.express_data.ship_no !== '' && trade.status === 2), 'done': (trade.express_data.ship_no !== '' && trade.status > 2)}"><span>已发货</span></div>
                <div class="step" :class="{'current': trade.status === 10}"><span>已到达</span></div>
              </div>
            </div>
            <div class="order-table table-responsive-sm" v-if="[1,2,10].includes(trade.status) && trade.tracking.length > 0">
              <table class="table mb-0 table-striped table-borderless" v-if="trade.express_data.carrier === 'SF'">
                <thead class="">
                <tr>
                  <th scope="col">时间</th>
                  <th scope="col">信息</th>
                  <th scope="col">地点</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="track in trade.tracking" :key="track.time">
                  <td>{{ (track.time / 1000) | timestamp2date }}</td>
                  <td>{{ track.desc }}</td>
                  <td>{{ track.areaName }}</td>
                </tr>
                </tbody>
              </table>
              <table class="table mb-0 table-striped table-borderless" v-else-if="trade.express_data.carrier === '4PX'">
                <thead class="">
                <tr>
                  <th scope="col">时间</th>
                  <th scope="col">信息</th>
                  <th scope="col">类型</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="track in trade.tracking" :key="track.time">
                  <td>{{ track.tkDate | utcDateStringFormat}}</td>
                  <td>{{ track.tkDesc }}</td>
                  <td>{{ track.tkCategoryName }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Trade } from '@/api/model'
import { getTrade } from '@/api/trade'
import { baseMixin } from '@/libs/app-mixin'

export default {
  name: 'MyTrade',
  mixins: [baseMixin],
  data () {
    return {
      trade_id: '',
      trade: Trade()
    }
  },
  methods: {
    goMyPage () {
      location.href = '/#/my/dashboard'
      window.scrollTo(0, 0)
    },
    getTrade () {
      getTrade({
        trade_id: this.trade_id
      }).then(res => {
        if (res.code !== 200) {
          this.$message.info(res.msg)
          return false
        }
        this.trade = res.result
      })
    }
  },
  mounted () {
    this.trade_id = this.$route.params.trade_id
    this.getTrade()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/My/Trade.vue